import * as d3 from "d3";
import { DateTime } from "luxon";
// import chroma from "chroma-js";





const margin = {top: 30, right: 30, bottom: 37, left: 40};
// const margin = {top: 30, right: 0, bottom: 37, left: 40};
// const margin = {top: 10, right: 30, bottom: 37, left: 40};
// const margin = {top: 31, right: 30, bottom: 10, left: 40};

// let colorTableJson;
// const COLOR_TABLE_JSON_URL = "/static/colorTable.json";
// const COLOR_TABLE_JSON_URL = "/static/colorTable-old.json";

const WASTEWATER_COLORS_LIGHT = {
  'north': '#c8dbb8',
  'south': '#f1d1b8',
  'avg': '#aaa'
};
const WASTEWATER_COLORS_DARK = {
  'north': '#94B874',
  'south': '#E19963',
  'avg': '#999'
};

// let LINEAGE_LIST = [];
// const LINEAGE_THRESHOLDS_JSON_URL = "/static/lineage_thresholds/USA_Massachusetts.json";

// let allLineages = [];
// const RT_FILE = "/static/estimated_rt.json";
// const CASES_FILE = "/static/estimated_cases.json";
const WASTEWATER_FILE = "/static/wastewater.json";

let currentSeries = null,
  currentDate = null;

let dates = [],
  // casesByLineage = [],
  // rtByLineage = [],
  wastewater = {};
  // stack = null;

// let recentX = null,
// alltimeX = null,
// casesY = null,
// rtY = null,
// wastewaterY = null;
let x = null,
  y = null;

let alltimeStartDate = null;
let recentStartDate = null;
let startDate = null;
// const today = DateTime.now().set({hour: 0, minute: 0, second: 0, millisecond: 0});
// const today = DateTime.now().startOf("day");
const NUM_RECENT_DAYS = 90;

const readoutTemplate = document.querySelector(".readout--metric");
readoutTemplate.remove();

async function getWastewater() {
  return fetch(WASTEWATER_FILE)
    .then(res => res.json());
}

init();

async function init() {
  const wastewaterData = await getWastewater();

  // last update
  const biobotUpdate = DateTime.fromISO(wastewaterData.last_update["Biobot Analytics"]);
  document.querySelector("#last-update-biobot").innerText = biobotUpdate.toLocaleString(DateTime.DATE_FULL, {locale: 'en-US'});

  wastewater = {
    'north': wastewaterData.north,
    'south': wastewaterData.south,
    'avg': wastewaterData.avg
  };

  dates = wastewaterData.dates.map(d => DateTime.fromISO(d));
  alltimeStartDate = dates[0];
  const lastDate = dates[dates.length - 1];
  recentStartDate = lastDate.minus({ days: NUM_RECENT_DAYS });

  // dates
  // const firstDate = DateTime.max(DateTime.fromISO(rtData.dates[0]), DateTime.fromISO(casesData.dates[0]));
  // const endDate = DateTime.fromJSDate(new Date()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }); // today?
  // let tempDate = firstDate;
  // recentDates = [];
  // while (tempDate <= endDate) {
  //   recentDates.push(tempDate);
  //   tempDate = tempDate.plus({ days: 1 });
  // }

  // trim
  // let startIndex = casesData.dates.indexOf(firstDate.toISODate());
  // let endIndex = casesData.dates.indexOf(endDate.toISODate());
  // for (const lineage in casesByLineage) {
  //   casesByLineage[lineage] = casesByLineage[lineage].slice(startIndex);
  //   if (endIndex !== -1) {
  //     casesByLineage[lineage] = casesByLineage[lineage].slice(0, endIndex + 1);
  //   }
  // }
  // startIndex = rtData.dates.indexOf(firstDate.toISODate());
  // endIndex = rtData.dates.indexOf(endDate.toISODate());
  // for (const lineage in rtByLineage) {
  //   rtByLineage[lineage] = rtByLineage[lineage].slice(startIndex);
  //   if (endIndex !== -1) {
  //     rtByLineage[lineage] = rtByLineage[lineage].slice(0, endIndex + 1);
  //   }
  // }

  // time range
  const rangeOptionsForm = document.querySelector(".time-range-form");
  rangeOptionsForm.addEventListener("input", () => {
    const value = rangeOptionsForm.timeRange.value;
    setTimeRange(value);
    drawCharts();

    if (value === "recent") {
      const monthTexts = document.querySelectorAll(".x-axis-month text");
      const yearTexts = document.querySelectorAll(".x-axis-year text");
      const gridLines = document.querySelectorAll(".x-axis-grid line");
      let currentMonth = null;
      for (let i = 0; i < monthTexts.length; i++) {
        const date = d3.select(monthTexts[i]).data()[0];
        const month = d3.timeMonth(date);
        let secondary = true;
        if (month === date) {
          secondary = false;
        } else if (!currentMonth || month > currentMonth) {
          secondary = false;
        }
        monthTexts[i].classList.toggle("secondary", secondary);
        yearTexts[i].classList.toggle("secondary", secondary);
        gridLines[i].classList.toggle("secondary", secondary);
        currentMonth = month;
      }
    } else {
      d3.selectAll(".x-axis-month text")
        .classed("secondary", false);
    }
  });

  setTimeRange(rangeOptionsForm.timeRange.value);

  // createCharts();
  window.addEventListener("resize", drawCharts);

  drawCharts();
}

function setTimeRange(value) {
  if (value === "recent") {
    startDate = recentStartDate;
  } else {
    startDate = alltimeStartDate;
  }
}

// function createCharts() {
//   createChart(wastewater, document.querySelector(".wastewater .card--chart"), "wastewater");
//   mouseout();
// }

function drawCharts() {
  drawChart(wastewater, document.querySelector(".wastewater .card--chart"), "wastewater");
}

// function createChart(data, container, title) {
//   // container
//   d3.select(container)
//     .on("mousemove", e => {
//       const target = e.target.closest(".series") || e.target;
//       currentSeries = target.getAttribute("data-series");
//       hoverCoords(e);
//     })
//     .on("mouseout", mouseout);

//   // series and legend
//   let series = Object.keys(data);
//   if (series.length > 0) {
//     createLegend(container, series);
//   }

//   // svg
//   const svg = d3.select(container).append("svg")
//     .attr("width", "100%")
//     .attr("height", "100%")

//   // axes and grid lines
//   createAxes(svg);

//   // data layer
//   const g = svg.append("g")
//     .attr("transform", `translate(${margin.left}, ${margin.top})`)
//     .classed("data", true);
//   g.attr("width", "100%")
//     .attr("height", "100%");

//   g.append("g")
//     .classed("areas", true)
//     .selectAll(".area")
//     .data(Object.values(data))
//     .enter()
//     .append("path")
//     .classed("area", true)
//     .attr("data-series", (d, i) => Object.keys(wastewater)[i])
//     .attr("fill", (d, i) => {
//       const key = Object.keys(wastewater)[i];
//       return WASTEWATER_COLORS_LIGHT[key];
//     });

//   g.append("g")
//     .classed("lines", true)
//     .selectAll(".line")
//     .data(Object.values(data))
//     .enter()
//     .append("path")
//     .classed("line", true)
//     .attr("data-series", (d, i) => Object.keys(wastewater)[i])
//     .attr("fill", "none")
//     .attr("stroke", (d, i) => {
//       const key = Object.keys(wastewater)[i];
//       return WASTEWATER_COLORS_LIGHT[key];
//     })
//     .attr("stroke-width", 2.5);

//   const dots = g.append("g")
//     .classed("dots", true);
//   for (const key in data) {
//     dots.append("circle")
//       .classed("dot", true)
//       .attr("id", `wastewater-dot--${key}`)
//       .attr("fill", WASTEWATER_COLORS_DARK[key])
//       .attr("r", 3);
//   }

//   drawChart(data, container, title);
// }

function createLegend(container, series) {
  const card = container.closest(".card");
  const legend = card.querySelector(".card--legend");
  const readoutContainer = card.querySelector(".card--readout");

  const createKey = (series) => {
    const seriesDiv = document.createElement("div");
    legend.appendChild(seriesDiv);
    seriesDiv.setAttribute("data-series", series);
    seriesDiv.classList.add("legend--key");
    seriesDiv.addEventListener("mousemove", () => hoverSeries(series));
    seriesDiv.addEventListener("mouseout", mouseout);

    const seriesSwatch = document.createElement("div");
    seriesDiv.appendChild(seriesSwatch);
    seriesSwatch.classList.add("legend--swatch");
    seriesSwatch.style.backgroundColor = WASTEWATER_COLORS_LIGHT[series];

    let seriesLabel = series;
    if (seriesLabel === "avg") {
      seriesLabel = "average";
    }
    seriesLabel = seriesLabel.slice(0, 1).toUpperCase() + seriesLabel.slice(1);

    const seriesName = document.createElement("div");
    seriesDiv.appendChild(seriesName);
    seriesName.innerText = seriesLabel;

    const seriesReadout = readoutTemplate.cloneNode(true);
    seriesReadout.id = `wastewater-readout--${series}`;
    seriesReadout.setAttribute("data-series", series);
    readoutContainer.appendChild(seriesReadout);
    const seriesLabelDiv = seriesReadout.querySelector(".metric--series");
    seriesLabelDiv.innerText = seriesLabel;
  }

  Object.keys(wastewater).forEach(key => {
    if (!(series.includes(key))) return;
    createKey(key);
  });
}

// function createAxes(svg) {
//   const LINE_HEIGHT = 12;

//   // x axis
//   const xAxis = svg.append("g")
//     .classed("x-axis", true)
//     .attr("transform", `translate(${margin.left}, ${margin.top - LINE_HEIGHT})`);
//   xAxis.append("g").classed("x-axis-month", true);
//   xAxis.append("g").classed("x-axis-year", true);

//   // y axis
//   svg.append("g")
//     .classed("y-axis", true)
//     .attr("transform", `translate(${margin.left}, ${margin.top})`);

//   // vertical grid lines
//   svg.append("g")
//     .classed("x-axis-grid", true)
//     .attr("transform", `translate(${margin.left}, ${margin.top})`)

//   // horizontal grid lines
//   svg.append("g")
//     .classed("y-axis-grid", true)
//     .attr("transform", `translate(${margin.left}, ${margin.top})`)
// }

function drawChart(data, container, title) {
  let startIndex = null;
  if (startDate === dates[0]) {
    startIndex = 0;
  } else {
    startIndex = dates.findLastIndex(d => d <= startDate);
  }
  const datesTrimmed = dates.slice(startIndex);
  const dataTrimmed = {};
  for (const key in data) {
    dataTrimmed[key] = data[key].slice(startIndex);
  }

  // min and max
  const min = 0;
  const max = d3.max(Object.values(dataTrimmed).flat().filter(d => d !== null));

  // svg
  let svg = d3.select(container).select("svg");
  if (!svg.node()) {
    svg = d3.create("svg")
      .attr("width", "100%")
      .attr("height", "100%");
    container.appendChild(svg.node());

    d3.select(container)
      .on("mousemove", e => {
        // const target = e.target.closest(".series") || e.target;
        // currentSeries = target.getAttribute("data-series");
        hoverCoords(e, datesTrimmed, dataTrimmed);
      })
      .on("mouseout", mouseout);

    // series and legend
    let series = Object.keys(data);
    if (series.length > 0) {
      createLegend(container, series);
    }
  }

  // metrics
  const bb = svg.node().getBoundingClientRect();
  const width = bb.width - margin.left - margin.right;
  const height = bb.height - margin.top - margin.bottom;

  // scales
  x = d3.scaleTime()
    .domain(d3.extent(datesTrimmed))
    .range([0, width]);
  // .nice()
  y = d3.scaleLinear()
    .domain([min, max])
    .range([height, 0])
    .nice();

  // x axis
  const LINE_HEIGHT = 12;
  let xAxis = svg.select(".x-axis");
  let xAxisMonth = xAxis.select(".x-axis-month");
  let xAxisYear = d3.select(container).select(".x-axis-year");
  if (!xAxis.node()) {
    xAxis = svg.append("g")
      .classed("x-axis", true)
      .attr("transform", `translate(${margin.left}, ${margin.top - LINE_HEIGHT})`);
    // .attr("transform", `translate(${margin.left}, ${height + margin.top})`);
    xAxisMonth = xAxis.append("g").classed("x-axis-month", true);
    xAxisYear = xAxis.append("g").classed("x-axis-year", true);
  }
  xAxisMonth
    .transition()
    .call(d3.axisTop(x).tickFormat(d3.timeFormat("%b")));
  // .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%b")));
  xAxisYear
    .transition()
    .call(d3.axisTop(x).tickFormat(d3.timeFormat("%Y")));
  // .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%Y")));
  xAxisYear.selectAll("text").attr("class", date => (d3.timeYear(date) < date) ? "secondary" : "");

  // y axis
  let yAxis = svg.select(".y-axis")
  if (!yAxis.node()) {
    yAxis = svg.append("g")
      .classed("y-axis", true)
      .attr("transform", `translate(${margin.left}, ${margin.top})`);
  }
  yAxis
    .transition()
    .call(d3.axisLeft(y));

  // horizontal grid lines
  let hGrid = svg.selectAll(".y-axis-grid");
  if (!hGrid.node()) {
    hGrid = svg.append("g")
      .classed("y-axis-grid", true)
      .attr("transform", `translate(${margin.left}, ${margin.top})`);
  }
  hGrid.transition().call(d3.axisLeft(y).tickSize(-width).tickFormat(""));

  // vertical grid lines
  let vGrid = svg.selectAll(".x-axis-grid");
  if (!vGrid.node()) {
    vGrid = svg.append("g")
      .classed("x-axis-grid", true)
      .attr("transform", `translate(${margin.left}, ${margin.top})`);
  }
  vGrid.transition().call(d3.axisTop(x).tickSize(-height).tickFormat(""));
  vGrid.selectAll("line").attr("class", date => (d3.timeYear(date) < date) ? "secondary" : "");

  // data layer
  let g = svg.select(".data");
  if (!g.node()) {
    g = svg.append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`)
      .classed("data", true)
      .attr("width", "100%")
      .attr("height", "100%");
  }

  // clip path
  let dataClip = svg.select(".data-clip rect"); // a fix for when the confidence areas overflow
  if (!dataClip.node()) {
    dataClip = svg.append("clipPath")
      .attr("id", `${title}-data-clip`)
      .classed("data-clip", true)
      .append("rect")
      .attr("x", 0)
      .attr("y", 0);
  }
  dataClip.attr("width", width)
    .attr("height", height);

  let areas = svg.select(".data");
  if (!areas.node()) {
    areas = g.append("g")
      .classed("areas", true)
  }
  areas.selectAll(".area")
    .data(Object.values(data))
    .join("path")
    .classed("area", true)
    .attr("data-series", (d, i) => Object.keys(wastewater)[i])
    .attr("fill", (d, i) => {
      const key = Object.keys(wastewater)[i];
      return WASTEWATER_COLORS_LIGHT[key];
    })
    .transition()
    .attr("d", d3.area()
      .x((_, i) => x(dates[i]))
      .y0(y(0))
      .y1(d => y(d))
      .defined((d, i) => dates[i] !== null && d !== null)
    )

  let lines = svg.select(".lines")
  if (!lines.node()) {
    lines = g.append("g")
      .classed("lines", true);
  }
  lines.selectAll(".line")
    .data(Object.values(data))
    .join("path")
    .classed("line", true)
    .attr("data-series", (_, i) => Object.keys(wastewater)[i])
    .attr("fill", "none")
    .attr("stroke", (_, i) => {
      const key = Object.keys(wastewater)[i];
      return WASTEWATER_COLORS_LIGHT[key];
    })
    .attr("stroke-width", (_, i) => {
      if (Object.keys(wastewater)[i] === "avg") {
        return 2.5;
      }
      return 1;
    })
    .transition()
    .attr("d", d3.line()
      .x((_, i) => x(dates[i]))
      .y(d => y(d))
      .defined((d, i) => dates[i] !== null && d !== null)
    );

  let level = svg.select(".card--readout--level");
  if (!level.node()) {
    level = svg.append("line")
      .classed("card--readout--level", true)
      .classed("hidden", true)
  }
  level.attr("x1", margin.left).attr("x2", width + margin.left);

  let dots = g.select(".dots");
  if (!dots.node()) {
    dots = g.append("g")
      .classed("dots", true);
    for (const key in data) {
      dots.append("circle")
        .classed("dot", true)
        .classed("hidden", true)
        .attr("id", `wastewater-dot--${key}`)
        .attr("fill", WASTEWATER_COLORS_DARK[key])
        .attr("r", 3);
    }
  }
}

function hoverCoords(e, datesTrimmed, dataTrimmed) {
  let [xCoord, yCoord] = d3.pointer(e);

  if (yCoord > y.range()[0] + margin.top) return;

  xCoord -= margin.left;
  let date = DateTime.fromJSDate(x.invert(xCoord));
  date = date.startOf("day");
  if (date < dates[0] || date > dates[dates.length - 1]) return;
  currentDate = date.setLocale("en-US");
  xCoord = x(date);

  hover(datesTrimmed, dataTrimmed);
}

function hoverSeries(series) {
  currentSeries = series;
  currentDate = null;
  document.querySelectorAll(".card").forEach(card => card.classList.add("hovering"));
  hover();
}

function hover() {
  // hiding and showing things
  const containers = document.querySelectorAll(".card");
  containers.forEach(container => {
    const xCoord = currentDate ? x(currentDate) + margin.left : 0;
    const dataIndex = currentDate ? dates.findIndex(d => d.toISODate() === currentDate.toISODate()) : null;

    if (xCoord && xCoord < margin.left) {
      container.classList.remove("hovering");

      // hide elements
      container.querySelector(".card--readout--line").classList.add("hidden");
      container.querySelector(".card--readout--level").classList.add("hidden");
      container.querySelectorAll(".readout--metric").forEach(readout => readout.classList.add("hidden"));
      container.querySelector(".readout--metric.highlighted")?.classList.remove("highlighted");
      container.querySelector(".readout--date").classList.add("hidden");

      // remove current class
      container.querySelectorAll(".area").forEach(area => area.classList.remove("current"));
      container.querySelectorAll(".line").forEach(line => line.classList.remove("current"));

      container.querySelectorAll(".dot").forEach(dot => dot.classList.add("hidden"));

      container.querySelectorAll(".y-axis-grid line").forEach(line => line.classList.remove("secondary"));

      return;
    }

    const chartEls = container.querySelectorAll(".area, .line, .series, .legend--key");
    if (currentSeries) {
      chartEls.forEach(el => el.classList.toggle("current", el.getAttribute("data-series") === currentSeries));
    }

    const toMove = container.querySelectorAll(".card--readout, .readout--date, .card--readout--line");
    toMove.forEach(el => el.style.left = `${xCoord}px`);

    let currentHeight = 0;
    for (const key in wastewater) {
      const wastewaterPoint = wastewater[key][dataIndex] ?? 0;
      currentHeight = Math.max(currentHeight, wastewaterPoint);
    }
    if (currentHeight) {
      currentHeight = y(currentHeight);
      currentHeight = (y.range()[0] - currentHeight) + 5;
    }
    currentHeight += margin.bottom;
    container.querySelector(".card--readout--line").style.bottom = `${currentHeight}px`;

    const readouts = container.querySelectorAll(".readout--metric");
    readouts.forEach(readout => {
      readout.classList.toggle("highlighted", currentDate && currentSeries === readout.getAttribute("data-series"));
    });
    if (currentDate && !currentSeries) {
      readouts.forEach(readout => readout.classList.add("highlighted"));
    }

    const readoutDates = container.querySelectorAll(".readout--date");
    readoutDates.forEach(readoutDate => {
      if (currentDate) {
        readoutDate.querySelector(".month").innerText = `${currentDate.monthShort} ${currentDate.day}`;
        readoutDate.querySelector(".year").innerText = currentDate.year;
      }
      readoutDate.classList.toggle("hidden", !currentDate);
    });

    const readoutLines = container.querySelectorAll(".card--readout--line");
    readoutLines.forEach(readoutLine => {
      readoutLine.classList.toggle("hidden", !currentDate);
    });

    container.querySelectorAll(".y-axis-grid line").forEach(line => {
      line.classList.add("secondary");
    });

    // filling in data
    if (currentDate) {
      for (const key in wastewater) {
        // const wastewaterPoint = wastewater[key][alltimeDataIndex] ?? null;
        const wastewaterPoint = wastewater[key][dataIndex] ?? null;
        const wastewaterReadout = document.querySelector(`#wastewater-readout--${key}`);
        wastewaterReadout.classList.toggle("hidden", !wastewaterPoint);
        if (wastewaterPoint) {
          wastewaterReadout.querySelector(".metric--count").innerText = d3.format(",")(Math.round(wastewaterPoint));

          d3.select(`#wastewater-dot--${key}`)
            .classed("hidden", false)
            .attr("cx", xCoord - margin.left)
            .attr("cy", y(wastewaterPoint))

          if (key === "avg") {
            d3.select(container).select(".card--readout--level")
              .classed("hidden", false)
              .attr("y1", `${y(wastewaterPoint) + margin.top}`)
              .attr("y2", `${y(wastewaterPoint) + margin.top}`)
          }
        }
      }
    }
  });
}

function mouseout() {
  currentSeries = null;
  currentDate = null;

  const cards = document.querySelectorAll(".card");
  cards.forEach(card => {
    card.classList.remove("hovering");

    // hide elements
    card.querySelector(".card--readout--line").classList.add("hidden");
    card.querySelector(".card--readout--level").classList.add("hidden");
    card.querySelectorAll(".readout--metric").forEach(readout => readout.classList.add("hidden"));
    card.querySelector(".readout--metric.highlighted")?.classList.remove("highlighted");
    card.querySelector(".readout--date").classList.add("hidden");

    card.querySelectorAll(".dot").forEach(dot => dot.classList.add("hidden"));

    // remove current class
    card.querySelectorAll(".area").forEach(area => area.classList.remove("current"));
    card.querySelectorAll(".line").forEach(line => line.classList.remove("current"));

    card.querySelectorAll(".y-axis-grid line").forEach(line => line.classList.remove("secondary"));
  });
}